import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';

const CompanyVeiwController = () => {
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};
  const getCompanies = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}companies/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_COMPANIES_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_COMPANIES_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };

  const addCompany = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}companies/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_COMPANY_SUCCESS", payload: data });
      dispatch(getCompanies());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Company added sucessfully");
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({ type: "ADD_COMPANY_FAILURE", payload: { error } });
      toast.error(message);
      return Promise.reject(error); // ✅ return error
      
    }
  };
  const updateCompany = (id, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}companies/${id}/`,
        reqData
      );
      dispatch({ type: "UPDATE_COMPANY_SUCCESS", payload: response.data });
      dispatch(getCompanies());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Company data updated sucessfully");
      return Promise.resolve(response.data);
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({ type: "UPDATE_COMPANY_FAILURE", payload: error });
      toast.error(message);
      return Promise.reject(error);
    }
  };

  // const updateCompany = (companyId, reqData) => async (dispatch) => {
  //   dispatch({ type: "LOADING", payload: true });
  //   try {
  //     const response = await axios.put(
  //       `http://127.0.0.1:8000/api/companies/${companyId}/`,
  //       reqData
  //     );

  //     const jsonString = JSON.stringify(response.data);
  //     const data = JSON.parse(jsonString);
  //     dispatch({ type: "UPDATE_COMPANY_SUCCESS", payload: data });
  //     dispatch(getCompanies());
  //     dispatch({ type: "LOADING", payload: false });
  //   } catch (error) {
  //     dispatch({ type: "LOADING", payload: false });
  //     dispatch({
  //       type: "UPDATE_COMPANY_FAILURE",
  //       payload: { error: error }
  //     });
  //   }
  // };

  const deleteCompany = (companyId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}companies/${companyId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_COMPANY_SUCCESS", payload: data });
      dispatch(getCompanies());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Company deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_COMPANY_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };
  const getAnnouncement = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}announcements/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_ANNOUNCEMENT_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
     
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_ANNOUNCEMENT_FAILURE",
        payload: { error: error }
      });
      toast.error(message)
    }
  };

  const AddAnnouncement = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}announcements/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_ANNOUNCEMENT_SUCCESS", payload: data });
      dispatch(getAnnouncement());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Announcement added sucessfully");
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({ type: "ADD_ANNOUNCEMENT_FAILURE", payload: { error } });
      toast.error(message);
      return Promise.reject(error); // ✅ return error
    }
  };
  const updateAnnouncement = (id, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}announcements/${id}/`,
        reqData
      );
      dispatch({ type: "UPDATE_ANNOUNCEMENT_SUCCESS", payload: response.data });
      dispatch(getAnnouncement());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Announcement updated sucessfully");
      return Promise.resolve(response.data);
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({ type: "UPDATE_ANNOUNCEMENT_FAILURE", payload: error });
      toast.error(message)
      return Promise.reject(error);
    }
  };
  return {
    getCompanies,
    addCompany,
    updateCompany,
    deleteCompany,
    getAnnouncement,
    AddAnnouncement,
    updateAnnouncement
  };
};

export default CompanyVeiwController;
